import React, { useState } from 'react';
import { Grid, IconButton, Menu, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import useConditionalLogicStore from '../useConditionalLogicStore';
import { Logic, SelectFuc } from './components';
import MentionEditor from '../../TextEditor/MentionEditor';
import { MoreHoriz } from '@mui/icons-material';

function ItemCondition(props) {
  const {
    indexCondition,
    indexStatement,
    indexLogic,
    statement,
    condition,
    availablePlaceholders,
    forceUpdateState,
  } = props;

  const [menu, setMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  let { positions, placeholders } = (props.componentStore || useConditionalLogicStore).getState();

  let keyArray = [];
  let valueArray = [];
  placeholders = placeholders;

  if (
    positions.indexLogic == indexLogic &&
    positions.indexStatement == indexStatement &&
    positions.indexCondition == indexCondition &&
    positions.type == 'KEY'
  ) {
    keyArray = placeholders;
  }

  if (
    positions.indexLogic == indexLogic &&
    positions.indexStatement == indexStatement &&
    positions.indexCondition == indexCondition &&
    positions.type == 'VALUE'
  ) {
    valueArray = placeholders;
  }

  return (
    <>
      <Grid
        container
        direction={'row'}
        alignItems={'center'}
        xs={12}
        className={`${props.classes.conditionSpacing}  ${
          indexCondition > 0 ? props.classes.conditionPartFrame : ''
        }`}
        spacing={2}
      >
        <Grid item xs={props.isExpanded ? 1 : 3}>
          {indexCondition > 0 ? (
            <Logic
              value={condition.logic}
              onChange={event => {
                (props.componentStore || useConditionalLogicStore).getState().setCondition(
                  event,
                  indexLogic,
                  indexStatement,
                  indexCondition,
                  'logic'
                );
                forceUpdateState();
              }}
            />
          ) : (
            <p className={!props.isExpanded && 'm-0'}>{indexStatement > 0 ? 'Else if' : 'If'}</p>
          )}
        </Grid>
        <Grid container item xs={props.isExpanded ? 4 : 12}>
          <MentionEditor
            style={{ width: '100%' }}
            availablePlaceholders={availablePlaceholders}
            placeholders={keyArray}
            text={condition.key}
            single={true}
            placeholder={'Insert a placeholder'}
            onChange={value => {
              (props.componentStore || useConditionalLogicStore).getState().setCondition(
                value,
                indexLogic,
                indexStatement,
                indexCondition,
                'key'
              );
            }}
            onFocus={() => {
              (props.componentStore || useConditionalLogicStore).getState().setPositions({
                indexLogic,
                indexStatement,
                indexCondition,
                type: 'KEY',
              });
            }}
          />
        </Grid>
        <Grid container item xs={props.isExpanded ? 2 : 4}>
          <SelectFuc
            value={condition.function}
            onChange={event => {
              (props.componentStore || useConditionalLogicStore).getState().setCondition(
                event,
                indexLogic,
                indexStatement,
                indexCondition,
                'function'
              );
              forceUpdateState();
            }}
          />
        </Grid>
        <Grid container item xs={props.isExpanded ? 4 : 12}>
          <MentionEditor
            style={{ width: '100%' }}
            availablePlaceholders={availablePlaceholders}
            placeholders={valueArray}
            text={condition.value}
            single={true}
            placeholder={'Insert a placeholder, text or integer'}
            onChange={value => {
              (props.componentStore || useConditionalLogicStore).getState().setCondition(
                value,
                indexLogic,
                indexStatement,
                indexCondition,
                'value'
              );
            }}
            onFocus={() => {
              let type = 'VALUE';
              (props.componentStore || useConditionalLogicStore).getState().setPositions({
                indexLogic,
                indexStatement,
                indexCondition,
                type,
              });
            }}
          />
        </Grid>
        {indexCondition > 0 ? (
          <Grid
            container
            xs={props.isExpanded ? 1 : 12}
            item
            direction={'row'}
            justifyContent={'flex-end'}
          >
            <IconButton
              onClick={event => {
                setMenu(true);
                setAnchorEl(event.currentTarget);
              }}
              className={'icon-btn'}
              size="large"
            >
              <MoreHoriz className={''} />
            </IconButton>
            {menu && (
              <Menu
                onClose={event => {
                  setMenu(false);
                }}
                open={menu}
                anchorEl={anchorEl}
              >
                <MenuItem
                  onClick={() => {
                    (props.componentStore || useConditionalLogicStore).getState().copyThisCondition(
                      indexLogic,
                      indexStatement,
                      indexCondition
                    );
                    forceUpdateState();
                    setMenu(false);
                    setAnchorEl(null);
                  }}
                >
                  Duplicate block
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    (props.componentStore || useConditionalLogicStore).getState().handleRemoveCondition(
                      indexLogic,
                      indexStatement,
                      condition.conditionRandomKey
                    );
                    forceUpdateState();
                    setMenu(false);
                    setAnchorEl(null);
                  }}
                >
                  Delete block
                </MenuItem>
              </Menu>
            )}
          </Grid>
        ) : (
          <Grid
            container
            xs={props.isExpanded ? 1 : 12}
            item
            direction={'row'}
            justifyContent={'flex-end'}
          >
            <IconButton
              onClick={event => {
                setMenu(true);
                setAnchorEl(event.currentTarget);
              }}
              className={'icon-btn'}
              size="large"
            >
              <MoreHoriz className={''} />
            </IconButton>
            {menu && (
              <Menu
                onClose={event => {
                  setMenu(false);
                }}
                open={menu}
                anchorEl={anchorEl}
              >
                <MenuItem
                  onClick={() => {
                    (props.componentStore || useConditionalLogicStore).getState().copyThisStatement(indexLogic, indexStatement);
                    props.forceUpdateStatement();
                    setMenu(false);
                    setAnchorEl(null);
                  }}
                >
                  Duplicate block
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    (props.componentStore || useConditionalLogicStore).getState().removeStatement(indexLogic, indexStatement);
                    props.forceUpdateStatement();
                    setMenu(false);
                    setAnchorEl(null);
                  }}
                >
                  Delete block
                </MenuItem>
              </Menu>
            )}
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default ItemCondition;
